import { faTooth } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { faSparkles } from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { faCheck, faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useLingui } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { claimNotesAtom } from '@/modules/claims/summary/state';
import { useClaimAttachmentDisclaimer } from '@/modules/insuranceExport/constants';

const SHARED_LIST_CLASSES = 'vai-ml-8 vai-mt-2';
const SHARED_ICON_CLASSES = 'vai-text-slate-600 vai-mr-2';
const SHARED_HEADING_CLASSES =
  'vai-flex vai-items-center vai-gap-2 vai-font-semibold';

export const SubmissionChecklist = () => {
  const claimNotes = useAtomValue(claimNotesAtom);

  const { t } = useLingui();
  const claimAttachmentDisclaimer = useClaimAttachmentDisclaimer();

  const DEFAULT_COMPLETED_ATTACHMENT_NOTES = [
    t`Selected images with diagnosis`,
    t`Generated narrative`,
    t`Documented findings`,
  ];

  return (
    <div >
      <h2 className="vai-font-semibold vai-text-lg">
        <Trans>Submission Checklist</Trans>
      </h2>
      <div className="vai-mt-4 first:vai-mt-0">
        {/* Yellow section, only show if there ARE notes */}
        {claimNotes.length > 0 ? (
          <div className="vai-bg-amber-50 vai-mt-4 vai-p-4 vai-rounded-md">
            <h3 className={`${SHARED_HEADING_CLASSES} vai-text-amber-600`}>
              <FontAwesomeIcon
                icon={faCirclePlus}
                className="vai-text-amber-500 vai-mr-1"
              />
              <Trans>To strengthen your claim:</Trans>
            </h3>
            <ul className={SHARED_LIST_CLASSES}>
              {claimNotes.map((note, index) => (
                <li key={index} className="vai-mt-1">
                  <FontAwesomeIcon
                    icon={faTooth}
                    className={SHARED_ICON_CLASSES}
                  />
                  <Trans>{note}</Trans>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          // Static green section, show if there are no notes
          <div className="vai-bg-green-50 vai-mt-4 vai-p-4 vai-rounded-md">
            <h3 className={`${SHARED_HEADING_CLASSES} vai-text-green-600`}>
              <FontAwesomeIcon
                icon={faSparkles}
                className="vai-text-green-600 vai-mr-1"
              />
              <Trans>This AI-generated attachment includes:</Trans>
            </h3>
            <ul className={SHARED_LIST_CLASSES}>
              {DEFAULT_COMPLETED_ATTACHMENT_NOTES.map((note, index) => (
                <li key={index}>
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={SHARED_ICON_CLASSES}
                  />
                  {note}
                </li>
              ))}
            </ul>
          </div>
        )}
        <div
          
          className="vai-mt-4 vai-text-sm vai-text-zinc-500"
        >
          {claimAttachmentDisclaimer}
        </div>
      </div>
    </div>
  );
};
